import React, { useState } from 'react';
import '../template/styles/Template.css';

function ApiKeys() {
  const [apiKeys, setApiKeys] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleCreateKey = () => {
    alert('API key generation coming soon!');
  };

  return (
    <div style={{
      maxWidth: '1000px',
      margin: '40px auto',
      padding: '0 20px'
    }}>
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ marginBottom: '10px' }}>🔑 API Keys</h1>
        <p style={{ color: '#666' }}>
          Manage API keys for programmatic access to DeepEcon data
        </p>
      </div>

      {/* Info Banner */}
      <div style={{
        padding: '20px',
        background: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px',
        marginBottom: '30px'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '10px', color: '#856404' }}>
          🚧 API Access Coming Soon
        </h3>
        <p style={{ margin: 0, color: '#856404' }}>
          Programmatic API access will be available in a future update. You'll be able to:
        </p>
        <ul style={{ marginTop: '10px', color: '#856404' }}>
          <li>Generate API keys for automated access</li>
          <li>Query sentiment data and breakpoints</li>
          <li>Access supply chain risk scores</li>
          <li>Retrieve GDP component indices</li>
        </ul>
      </div>

      {/* API Keys List */}
      <div style={{
        background: 'white',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '30px'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h2 style={{ margin: 0 }}>Your API Keys</h2>
          <button
            onClick={() => setShowCreateForm(!showCreateForm)}
            disabled
            style={{
              padding: '10px 20px',
              background: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontWeight: '500',
              cursor: 'not-allowed',
              opacity: 0.6
            }}
          >
            + Create New Key
          </button>
        </div>

        {apiKeys.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: '#999'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔑</div>
            <h3 style={{ color: '#ccc', marginBottom: '10px' }}>No API Keys Yet</h3>
            <p>Create your first API key to get started</p>
          </div>
        ) : (
          <div>
            {/* API keys will be listed here when available */}
          </div>
        )}
      </div>

      {/* Documentation Section */}
      <div style={{
        background: 'white',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '30px',
        marginTop: '20px'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '20px' }}>📚 API Documentation</h2>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>Base URL</h3>
          <code style={{
            display: 'block',
            padding: '10px',
            background: '#f5f5f5',
            borderRadius: '4px',
            fontFamily: 'monospace'
          }}>
            https://api.deepecon.info/api/deepdive
          </code>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>Example Endpoints (Future)</h3>
          <div style={{ color: '#666' }}>
            <p><code>GET /articles</code> - Retrieve analyzed articles</p>
            <p><code>GET /sentiment-chart</code> - Get sentiment data over time</p>
            <p><code>GET /breakpoints/recent</code> - Get recent breakpoints</p>
            <p><code>GET /supply-chain/sectors</code> - Get supply chain data</p>
            <p><code>GET /indices/all</code> - Get all GDP component indices</p>
          </div>
        </div>

        <div>
          <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>Authentication (Future)</h3>
          <p style={{ color: '#666' }}>
            API keys will be passed via the <code>Authorization</code> header:
          </p>
          <code style={{
            display: 'block',
            padding: '10px',
            background: '#f5f5f5',
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontSize: '14px',
            marginTop: '10px'
          }}>
            Authorization: Bearer your_api_key_here
          </code>
        </div>

        <div style={{
          marginTop: '30px',
          padding: '15px',
          background: '#e3f2fd',
          border: '1px solid #2196f3',
          borderRadius: '8px'
        }}>
          <strong style={{ color: '#1976d2' }}>ℹ️ Coming Soon</strong>
          <p style={{ margin: '5px 0 0 0', color: '#1976d2' }}>
            Full API documentation will be available when API access is launched
          </p>
        </div>
      </div>

      {/* Rate Limits Section */}
      <div style={{
        background: 'white',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '30px',
        marginTop: '20px'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '20px' }}>⚡ Rate Limits (Planned)</h2>

        <table style={{
          width: '100%',
          borderCollapse: 'collapse'
        }}>
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #e0e0e0' }}>Plan</th>
              <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #e0e0e0' }}>Requests/Hour</th>
              <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #e0e0e0' }}>Requests/Day</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Free</td>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>100</td>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>1,000</td>
            </tr>
            <tr style={{ background: '#f9f9f9' }}>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Premium</td>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>1,000</td>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>10,000</td>
            </tr>
            <tr>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Enterprise</td>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Unlimited</td>
              <td style={{ padding: '12px', border: '1px solid #e0e0e0' }}>Unlimited</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
          * Rate limits are subject to change and will be finalized upon API launch
        </p>
      </div>
    </div>
  );
}

export default ApiKeys;
